import React, { useEffect } from "react";
import {
  TextField,
  Box,
  Typography,
  Link,
  Paper,
  Checkbox
} from "@material-ui/core";
import { Form, Field } from "react-final-form";
import {
  IntroText,
  FormActionDrawer,
  GoGetDocWaitlist
} from "../../../components";
import createDecorator from "final-form-focus";
import { useHeader } from "../../../contexts";
import { string, object } from "yup";
import { useYupValidation } from "../../../hooks";
import { Trans, useTranslation } from "react-i18next";

const focusOnErrors = createDecorator();

const validationSchema = object({
  email: string()
    .email()
    .required()
    .trim()
    .label("Email")
});

const SchedulePatientContact = ({
  setDrawerClearance,
  updateScheduleData,
  scheduleData,
  isSubmitting
}) => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();

  useEffect(() => {
    setTitle(t("schedule.patient_contact.title"));
  }, []);

  const { validate } = useYupValidation();

  const validateForm = async data => {
    const errors = await validate(validationSchema)(data);

    if (errors) return errors;

    updateScheduleData({
      patientContact: data,
      ggd_waitlist: data.ggd_waitlist
    });
  };

  return (
    <>
      <Form
        onSubmit={validateForm}
        initialValues={{ ggd_waitlist: false, ...scheduleData.patientContact }}
        decorators={[focusOnErrors]}
        render={({ handleSubmit, submitErrors: errors = {} }) => (
          <form
            data-cy="schedule-screen-patient-contact"
            onSubmit={handleSubmit}
          >
            <Box mb={2}>
              <Paper>
                <Box p={2}>
                  <IntroText>
                    {t("schedule.patient_contact.intro_text")}
                  </IntroText>
                  <Field
                    name="email"
                    render={({ input }) => (
                      <TextField
                        {...input}
                        label={t("schedule.patient_contact.form.email.label")}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        error={!!errors.email}
                        helperText={errors.email}
                        inputProps={{
                          "data-lpignore": "true",
                          "data-cy": "input-email"
                        }}
                      />
                    )}
                  />
                  <Box mt={1}>
                    <Typography paragraph>
                      <Trans i18nKey="schedule.patient_contact.terms">
                        By choosing next, I acknowledge that I have reviewed and
                        electronically agree to the{" "}
                        <Link
                          href="https://www.gogettested.com/policy"
                          target="_blank"
                          rel="noopener"
                        >
                          terms and conditions and terms of use policy
                        </Link>
                      </Trans>
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Box>
            <Paper>
              <GoGetDocWaitlist
                formField={
                  <Field
                    name="ggd_waitlist"
                    type="checkbox"
                    render={({ input }) => (
                      <Checkbox
                        {...input}
                        inputProps={{
                          "data-cy": `input-ggd_waitlist`
                        }}
                        color="primary"
                      />
                    )}
                  />
                }
              />
            </Paper>
            <FormActionDrawer
              setDrawerClearance={setDrawerClearance}
              loading={isSubmitting}
            />
          </form>
        )}
      />
    </>
  );
};

export { SchedulePatientContact };
